// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { getBrand, getAPIConfig } from '@tcp/core/src/utils';
import Anchor from '../../../../../../../common/atoms/Anchor';
import ImageComp from './ImageComp';
import {
  getPdpAsPathurl,
  getPdpToPath,
} from '../../../../../OrderDetails/organism/OrderItem/views/OrderItem.view.utils';

export default function ImageWithUrl({
  pdpUrl,
  imgData,
  index,
  itemBrand,
  quantityToShow,
  wrappedItem,
  itemsHidden,
  isCrossBrandMerchandisingEnabled,
  disableVideoRender,
}) {
  let modifiedProductId = pdpUrl?.split('/p/')[1];
  if (modifiedProductId?.includes('.png')) {
    modifiedProductId = modifiedProductId?.split('.png')[0];
  }
  const getItemBrand = (brand) => brand && brand.toUpperCase();

  const currentSiteBrandName = getBrand();
  const apiConfigObj = getAPIConfig();
  const { crossDomain, brandSpecificCrossDomain } = apiConfigObj;
  const isProductBrandOfSameDomain = currentSiteBrandName.toUpperCase() === getItemBrand(itemBrand);
  const pdpToPath = getPdpToPath(
    isProductBrandOfSameDomain,
    crossDomain,
    brandSpecificCrossDomain,
    itemBrand,
    modifiedProductId,
    pdpUrl,
    isCrossBrandMerchandisingEnabled
  );

  const pdpAsPathUrl = getPdpAsPathurl(
    isProductBrandOfSameDomain,
    crossDomain,
    brandSpecificCrossDomain,
    itemBrand,
    modifiedProductId,
    pdpUrl,
    isCrossBrandMerchandisingEnabled
  );
  return (
    <>
      {pdpUrl === null ? (
        ImageComp({
          imgData,
          index,
          itemBrand,
          quantityToShow,
          wrappedItem,
          itemsHidden,
          disableVideoRender,
        })
      ) : (
        <Anchor
          to={pdpToPath}
          asPath={pdpAsPathUrl}
          noLink={false}
          IsSlugPathAdded
          useRouterNavigation
        >
          {ImageComp({
            imgData,
            index,
            itemBrand,
            quantityToShow,
            wrappedItem,
            itemsHidden,
            disableVideoRender,
          })}
        </Anchor>
      )}
    </>
  );
}
